import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { routes } from "./routes"; // Import the routes
import { ConfigProvider } from "antd";
import { TourProvider } from "./hooks/TourContext";
import { ThemeProvider as AmplifyProvider } from "@aws-amplify/ui-react";
import configureAuth from "./configureEnvironment/configureAuth";
import AuthenticatorWrapper from "./components/Utils/AuthenticatorWrapper";
import "@aws-amplify/ui-react/styles.css";
import frBE from "antd/locale/fr_BE";

import "./App.css";
//import "antd/dist/reset.css";
import "./index.css";

export const queryClient = new QueryClient();

const router = createBrowserRouter(routes);

export const shouldSkipAuth = () => process.env.REACT_APP_SKIP_AUTH === "SKIP";

if (!shouldSkipAuth()) {
  configureAuth();
}

const locale = frBE;

const App = () => (
  <AmplifyProvider>
    <AuthenticatorWrapper>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          theme={{
            token: {
              // Seed Token
              colorPrimary: "#e00103",
              colorLink: "#e00103",
              //borderRadius: 16,

              // Alias Token
              //colorBgContainer: "#f5f4f6",
            },
          }}
        >
          <ConfigProvider locale={locale}>
            <TourProvider>
              <RouterProvider router={router} />
            </TourProvider>
          </ConfigProvider>
        </ConfigProvider>
        {window.location.hostname === "localhost" && <ReactQueryDevtools />}
      </QueryClientProvider>
    </AuthenticatorWrapper>
  </AmplifyProvider>
);

export default App;
